import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { useDocumentContext } from "../../../context/DocumentContext/DocumentContext";


const CategoryDetail = () => {
	const { docCategoryDetail } = useDocumentContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={5}>
					<InputNumberComponent
						title={"Kategori Sıra No"}
						placeholder=""
						value={docCategoryDetail?.categoryNo}
						isDisabled
					/>
				</Col>
				<Col span={15}>
					<InputComponent
						title={"Kategori Adı"}
						placeholder=""
						value={docCategoryDetail?.categoryName}
						isDisabled
					/>
				</Col>
			</Row >
		</>
	);
};

export default CategoryDetail;
